module.exports = __webpack_public_path__ + "icons/original/small/small-d1.4623124355805891864ed2e7f2bec09a.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-d1.png
// module id = C7Cf
// module chunks = app